var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabHeaders, function(tabName) {
            return _c("v-tab", { key: tabName, attrs: { ripple: "" } }, [
              _vm._v("\n     " + _vm._s(tabName) + "\n    ")
            ])
          }),
          _vm._v(" "),
          _vm._l(2, function(n, index) {
            return _c("v-tab-item", { key: index }, [
              _vm.tab === 0 && index === 0
                ? _c(
                    "div",
                    [
                      _c("PaginationController", {
                        attrs: {
                          getDataActionName: "getReturnPackagesWithPagination",
                          haveSearchBox: "",
                          keepKeywordCase: "",
                          haveStartDate: "",
                          select: _vm.selectedValue,
                          searchBoxLabel: _vm.isAdmin
                            ? _vm.$t("trackingNumber") +
                              " / " +
                              _vm.$t("clientName")
                            : _vm.$t("trackingNumber"),
                          historyLimit: _vm.historyLimit,
                          isRefreshSelect: false,
                          isStartWithoutData: true
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "beforeSearchBox",
                              fn: function() {
                                return [
                                  _c(
                                    "v-flex",
                                    { attrs: { md4: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.returnPkgStatus,
                                          label: _vm.$t("selectStatus"),
                                          "item-text": "displayName",
                                          "item-value": "key"
                                        },
                                        model: {
                                          value: _vm.selectedValue,
                                          callback: function($$v) {
                                            _vm.selectedValue = $$v
                                          },
                                          expression: "selectedValue"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            _vm.isAdmin
                              ? {
                                  key: "beforeMenu",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "headline",
                                          attrs: { md1: "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                disabled: !_vm.eeveeOrgId
                                              },
                                              on: { click: _vm.addNewPackage }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("add")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("returnPackages")
                                                  )
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.eeveeOrgId
                                        ? _c(
                                            "v-flex",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "returnPackageFloatText"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("apiIdIsRequired")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                }
                              : null,
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.returnPackages,
                                      "hide-actions": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n               " +
                                                      _vm._s(props.index + 1) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    "\n               " +
                                                      _vm._s(
                                                        props.item
                                                          .trackingNumber
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    "\n               " +
                                                      _vm._s(
                                                        props.item.clientName ||
                                                          "[" +
                                                            props.item.orgId +
                                                            "]"
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toDateYYYYMMDD(
                                                        props.item
                                                          .returnCreateTime
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { column: "" } },
                                                    [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t("status") +
                                                                ": " +
                                                                _vm.$t(
                                                                  props.item
                                                                    .status ===
                                                                    "error"
                                                                    ? "returnError"
                                                                    : props.item
                                                                        .status
                                                                )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      (
                                                        props.item.comments ||
                                                        []
                                                      ).length
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "text-truncate",
                                                              attrs: {
                                                                "mb-2": "",
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "mr-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .comments[
                                                                          props
                                                                            .item
                                                                            .comments
                                                                            .length -
                                                                            1
                                                                        ].name
                                                                      ) +
                                                                      "\n                      [" +
                                                                      _vm._s(
                                                                        _vm.toDateMMDDHHmm(
                                                                          props
                                                                            .item
                                                                            .comments[
                                                                            props
                                                                              .item
                                                                              .comments
                                                                              .length -
                                                                              1
                                                                          ]
                                                                            .createTime
                                                                        )
                                                                      ) +
                                                                      "]: \n                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.lastCommentPreview(
                                                                      props.item
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.isAdmin
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "white-space":
                                                              "normal"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                props.item
                                                                  .note || ""
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": "",
                                                        "justify-center": ""
                                                      }
                                                    },
                                                    [
                                                      _vm.isAdmin
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { md3: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary",
                                                                    disabled: !(
                                                                      props.item
                                                                        .readyLabels &&
                                                                      props.item
                                                                        .readyLabels
                                                                        .length
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.downLoadLabel(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "font-size":
                                                                                          "25px"
                                                                                      },
                                                                                      attrs: {
                                                                                        color:
                                                                                          "primary",
                                                                                        small:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "cloud_download"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "download"
                                                                            )
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isAdmin
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { md3: "" }
                                                            },
                                                            [
                                                              _vm.isAdmin
                                                                ? _c(
                                                                    "v-menu",
                                                                    {
                                                                      attrs: {
                                                                        "offset-y":
                                                                          ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-tooltip",
                                                                                  {
                                                                                    attrs: {
                                                                                      top:
                                                                                        ""
                                                                                    },
                                                                                    scopedSlots: _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key:
                                                                                            "activator",
                                                                                          fn: function(
                                                                                            tooltip
                                                                                          ) {
                                                                                            return [
                                                                                              _c(
                                                                                                "div",
                                                                                                _vm._g(
                                                                                                  {},
                                                                                                  tooltip.on
                                                                                                ),
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-btn",
                                                                                                    {
                                                                                                      attrs: {
                                                                                                        icon:
                                                                                                          "",
                                                                                                        color:
                                                                                                          "primary",
                                                                                                        flat:
                                                                                                          ""
                                                                                                      },
                                                                                                      on: {
                                                                                                        click: function(
                                                                                                          $event
                                                                                                        ) {
                                                                                                          $event.stopPropagation()
                                                                                                          return on.click.apply(
                                                                                                            null,
                                                                                                            arguments
                                                                                                          )
                                                                                                        }
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "v-icon",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "build"
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ],
                                                                                                    1
                                                                                                  )
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ]
                                                                                          }
                                                                                        }
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    )
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                          " +
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "more"
                                                                                          )
                                                                                        ) +
                                                                                        "\n                        "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-list",
                                                                        [
                                                                          _c(
                                                                            "v-list-tile",
                                                                            {
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.editSinglePackage(
                                                                                    props.item
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-tile-title",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "edit"
                                                                                      )
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "v-list-tile",
                                                                            {
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteSinglePackage(
                                                                                    props.item
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-tile-title",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "delete"
                                                                                      )
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isAdmin &&
                                                      _vm.isShowTenantBtns(
                                                        props.item
                                                      )
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { md3: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "primary",
                                                                    icon: "",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.showResendPopup(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      attrs: {
                                                                                        color:
                                                                                          "primary",
                                                                                        small:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "schedule_send"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "requestResend"
                                                                            )
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isAdmin &&
                                                      _vm.isShowTenantBtns(
                                                        props.item
                                                      )
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { md3: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "primary",
                                                                    icon: "",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.requestForDisposal(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "activator",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var on =
                                                                                ref.on
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      attrs: {
                                                                                        color:
                                                                                          "primary",
                                                                                        small:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "recycling"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "requestDisposal"
                                                                            )
                                                                          ) +
                                                                          "\n                      "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "chatRoom",
                                                          attrs: { md3: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                icon: "",
                                                                flat: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showChatRoom(
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    top: ""
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              _vm._g(
                                                                                {
                                                                                  attrs: {
                                                                                    color:
                                                                                      "primary",
                                                                                    small:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  "comment"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "open"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.checkNewMessage(
                                                                props.item
                                                              )
                                                                ? _c(
                                                                    "v-badge",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "red"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "badge",
                                                                            fn: function() {
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      "font-size":
                                                                                        "10px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "new"
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            },
                                                                            proxy: true
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    }
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.returnPackages,
                          callback: function($$v) {
                            _vm.returnPackages = $$v
                          },
                          expression: "returnPackages"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowNewPackagePopup
                        ? _c("FormSubmitPopup", {
                            attrs: {
                              title: _vm.$t("addPackage"),
                              label: _vm.$t("addPackage"),
                              rightMethod: _vm.saveNewPackages,
                              rightButtonDisabled: !_vm.newItemList.length,
                              large: ""
                            },
                            on: {
                              popupClose: function() {
                                return _vm.closeAddPackagePopup()
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "justify-start": "",
                                            "align-center": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md2: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "primary" },
                                                  on: { click: _vm.addNewItem }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mx-2",
                                                      attrs: {
                                                        dark: "",
                                                        left: ""
                                                      }
                                                    },
                                                    [_vm._v("add")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("package")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md2: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    title: "importFile",
                                                    loading: _vm.isUploadingFile
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        left: ""
                                                      }
                                                    },
                                                    [_vm._v("cloud_upload")]
                                                  ),
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(_vm.$t("upload")) +
                                                      "\n                  "
                                                  ),
                                                  _c("input", {
                                                    ref: "fileUploader",
                                                    refInFor: true,
                                                    staticClass: "hideInput",
                                                    attrs: {
                                                      type: "file",
                                                      accept: ".csv,.xls,.xlsx"
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.analysizeFileData
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md2: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "primary" },
                                                  on: {
                                                    click:
                                                      _vm.downloadReturnTemplate
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mx-2",
                                                      attrs: {
                                                        dark: "",
                                                        left: ""
                                                      }
                                                    },
                                                    [_vm._v("cloud_download")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("template")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.isAfterCheck &&
                                          !_vm.isAvailableToSubmit &&
                                          _vm.newItemList.length
                                            ? _c("v-flex", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "returnPackageTipForAdd"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-form",
                                        {
                                          ref: "addPkgPopupForm",
                                          refInFor: true
                                        },
                                        _vm._l(_vm.newItemList, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: index,
                                              attrs: {
                                                "justify-space-between": "",
                                                "align-baseline": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      style: {
                                                        backgroundColor:
                                                          item.isExists &&
                                                          !_vm.returnPackageCache.includes(
                                                            item.trackingNumber
                                                          ) &&
                                                          !_vm.localReturnPkgTrackingCacheRepeated.includes(
                                                            item.trackingNumber
                                                          )
                                                            ? ""
                                                            : item.isExists ===
                                                                false ||
                                                              _vm.localReturnPkgTrackingCacheRepeated.includes(
                                                                item.trackingNumber
                                                              ) ||
                                                              _vm.returnPackageCache.includes(
                                                                item.trackingNumber
                                                              )
                                                            ? "yellow"
                                                            : ""
                                                      },
                                                      attrs: {
                                                        "justify-space-around":
                                                          "",
                                                        "align-center": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md3: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "trackingNumber"
                                                              ),
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  _vm.$t(
                                                                    "trackingNumber"
                                                                  )
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                item.trackingNumber,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "trackingNumber",
                                                                  typeof $$v ===
                                                                    "string"
                                                                    ? $$v.trim()
                                                                    : $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.trackingNumber"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            md2: "",
                                                            "ml-4": ""
                                                          }
                                                        },
                                                        [
                                                          _c("DatePicker", {
                                                            model: {
                                                              value:
                                                                item.returnCreateTime,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "returnCreateTime",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.returnCreateTime"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            md3: "",
                                                            "ml-4": ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              items:
                                                                _vm.statusList,
                                                              label: _vm.$t(
                                                                "status"
                                                              ),
                                                              "item-text":
                                                                "displayName",
                                                              "item-value":
                                                                "key",
                                                              clearable: ""
                                                            },
                                                            model: {
                                                              value:
                                                                item.status,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "status",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.status"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      !_vm.returnPackageCache.includes(
                                                        item.trackingNumber
                                                      ) &&
                                                      !_vm.localReturnPkgTrackingCacheRepeated.includes(
                                                        item.trackingNumber
                                                      ) &&
                                                      !item.errMsg
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md2: "",
                                                                "ml-4": ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    item.clientName ||
                                                                      item.orgId ||
                                                                      ""
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md2: "",
                                                                "ml-4": ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.returnPackageCache.includes(
                                                                      item.trackingNumber
                                                                    )
                                                                      ? _vm.$t(
                                                                          "historyDuplicated"
                                                                        )
                                                                      : _vm.localReturnPkgTrackingCacheRepeated.includes(
                                                                          item.trackingNumber
                                                                        )
                                                                      ? _vm.$t(
                                                                          "localDuplicated"
                                                                        )
                                                                      : item.errMsg
                                                                      ? _vm.$t(
                                                                          "notFound"
                                                                        )
                                                                      : ""
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            md1: "",
                                                            "ml-2": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                flat: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeItemFromList(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("delete")
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.isShowNewPackagePopup,
                              callback: function($$v) {
                                _vm.isShowNewPackagePopup = $$v
                              },
                              expression: "isShowNewPackagePopup"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowEditPackagePopup
                        ? _c("FormSubmitPopup", {
                            attrs: {
                              title: _vm.$t("editPackage"),
                              label: _vm.$t("editPackage"),
                              leftMethod: _vm.closeEditPackagePopup,
                              rightMethod: _vm.updatePackage,
                              medium: ""
                            },
                            on: {
                              popupClose: function() {
                                return _vm.closeEditPackagePopup()
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-around": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md5: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "trackingNumber"
                                                  ),
                                                  disabled: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.packageInEdit
                                                      .trackingNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.packageInEdit,
                                                      "trackingNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "packageInEdit.trackingNumber"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md5: "" } },
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  items: _vm.statusList,
                                                  label: _vm.$t("selectStatus"),
                                                  "item-text": "displayName",
                                                  "item-value": "key"
                                                },
                                                model: {
                                                  value:
                                                    _vm.packageInEdit.status,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.packageInEdit,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "packageInEdit.status"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { "justify-center": "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md11: "" } },
                                            [
                                              _c("v-textarea", {
                                                staticClass: "thinBox",
                                                attrs: {
                                                  label: _vm.$t("note"),
                                                  outline: "",
                                                  rows: "4",
                                                  counter: _vm.noteLengthLimit
                                                },
                                                model: {
                                                  value: _vm.packageInEdit.note,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.packageInEdit,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "packageInEdit.note"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.isShowEditPackagePopup,
                              callback: function($$v) {
                                _vm.isShowEditPackagePopup = $$v
                              },
                              expression: "isShowEditPackagePopup"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tab === 1 && index === 1
                ? _c(
                    "div",
                    [
                      _c("PaginationController", {
                        attrs: {
                          getDataActionName: "getReturnPackagesWithPagination",
                          haveSearchBox: _vm.isAdmin ? true : false,
                          keepKeywordCase: "",
                          searchBoxLabel:
                            _vm.$t("trackingNumber") +
                            " / " +
                            _vm.$t("clientName"),
                          historyLimit: _vm.historyLimit,
                          actionPredicates: _vm.historyActionPredicates,
                          isRefreshSelect: false,
                          isStartWithoutData: true
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.archivedHeaders,
                                      items: _vm.archivedPackages,
                                      "hide-actions": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n               " +
                                                      _vm._s(props.index + 1) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        props.item
                                                          .trackingNumber
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        props.item.clientName
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toDateYYYYMMDD(
                                                        props.item
                                                          .returnCreateTime
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { column: "" } },
                                                    [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t("status") +
                                                                ": " +
                                                                _vm.$t(
                                                                  props.item
                                                                    .status
                                                                )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      (
                                                        props.item.comments ||
                                                        []
                                                      ).length
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "text-truncate",
                                                              attrs: {
                                                                "mb-2": "",
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "mr-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .comments[
                                                                          props
                                                                            .item
                                                                            .comments
                                                                            .length -
                                                                            1
                                                                        ].name
                                                                      ) +
                                                                      "\n                      [" +
                                                                      _vm._s(
                                                                        _vm.toDateMMDDHHmm(
                                                                          props
                                                                            .item
                                                                            .comments[
                                                                            props
                                                                              .item
                                                                              .comments
                                                                              .length -
                                                                              1
                                                                          ]
                                                                            .createTime
                                                                        )
                                                                      ) +
                                                                      "]: \n                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.lastCommentPreview(
                                                                      props.item
                                                                    )
                                                                  ) +
                                                                  "\n                "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.isAdmin
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left",
                                                      style: (_vm.whiteSpace =
                                                        "pre")
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            props.item.note ||
                                                              ""
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.archivedPackages,
                          callback: function($$v) {
                            _vm.archivedPackages = $$v
                          },
                          expression: "archivedPackages"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShowChatRoom
        ? _c("ChatRoom", {
            attrs: {
              title: _vm.$t("supportChatRoomTitle", {
                caseNumber: _vm.packageInEdit.trackingNumber,
                status: _vm.$t(_vm.packageInEdit.status)
              }),
              docPath: ["returnPackages", _vm.packageInEdit.trackingNumber],
              comments: _vm.comments,
              lastReadTime: _vm.getLastReadTime(_vm.packageInEdit),
              readOnly:
                _vm.packageInEdit && _vm.packageInEdit.status === "done",
              nickName: _vm.isAdmin ? _vm.agent : "",
              enableFileUpload: ""
            },
            on: {
              add: _vm.getNewComment,
              getLocalUnread: _vm.updateLocalLastReadTime
            },
            scopedSlots: _vm._u(
              [
                _vm.isAdmin
                  ? {
                      key: "operation",
                      fn: function() {
                        return [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "no-wrap": "",
                                "align-baseline": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                [
                                  _vm.packageInEdit.status !== "done"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.updatePackage({}, true)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("resolve")))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            ),
            model: {
              value: _vm.isShowChatRoom,
              callback: function($$v) {
                _vm.isShowChatRoom = $$v
              },
              expression: "isShowChatRoom"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowResendPopup
        ? _c("SimpleTextPopup", {
            attrs: {
              rightMethod: _vm.requestForResend,
              rightButtonDisabled: !_vm.uploadedFile.length,
              rightButtonText: _vm.$t("submit"),
              medium: ""
            },
            on: {
              popupClose: function() {
                return (_vm.isShowResendPopup = false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                column: "",
                                "justify-center": "",
                                "align-center": ""
                              }
                            },
                            [
                              _c("v-flex", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("createTime") +
                                      ": " +
                                      _vm.toDateYYYYMMDD(
                                        _vm.packageInEdit.returnCreateTime
                                      )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-flex", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("status") +
                                      ": " +
                                      _vm.$t(_vm.packageInEdit.status)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("UploadFileWidget", {
                                    staticClass: "returnPackageUploader",
                                    attrs: {
                                      maxFiles: 1,
                                      iconType: "attachment",
                                      type:
                                        "returnPackagesLabel" +
                                        "/" +
                                        _vm.packageInEdit.billingNumber
                                    },
                                    model: {
                                      value: _vm.uploadedFile,
                                      callback: function($$v) {
                                        _vm.uploadedFile = $$v
                                      },
                                      expression: "uploadedFile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              747007055
            ),
            model: {
              value: _vm.isShowResendPopup,
              callback: function($$v) {
                _vm.isShowResendPopup = $$v
              },
              expression: "isShowResendPopup"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b402426", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b402426","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnPackages.vue
// module id = null
// module chunks = 